export const EvaluationWidget = (callback = null, key: string) => {
  const existingScript = document.getElementById('trackwidget-js');
  if (!existingScript) {
    const script = document.createElement('script');
    script.src = 'https://app.track.co/widget.min.js';
    script.type = 'text/javascript';
    script.id = 'trackwidget-js';
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      if (callback) callback();
      const instanceWidget = new (window as any).TrackWidget();
      instanceWidget.createWidget({ key });
    };
  }
  if (existingScript && callback) callback();
};
